// extracted by mini-css-extract-plugin
export default {"panelLeft":"LeftPanel_panelLeft__nYMM9","teeth":"LeftPanel_teeth__sOUgV"};